import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=701e08ba&scoped=true"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e08ba",
  null
  
)

export default component.exports